/**
 * 搜索引擎来源：根据 document.referrer 写入 seoSearchSource Cookie（原 server/middleware/pageCache.ts 逻辑迁至客户端）
 *
 * 说明：
 * - 仅在浏览器执行；依赖首屏导航时的 document.referrer（与 HTTP Referer 在策略收紧时可能不一致）
 * - 客户端无法设置 HttpOnly，故该 Cookie 可被页面脚本读取（与原先服务端 Set-Cookie 不同）
 * - Cookie 值与旧版一致为截断后的 referrer 字符串（未 URL 编码）；若值中含 ; 等字符可能被浏览器截断，与旧服务端行为相同风险
 */
const seoList = ['baidu.com', 'google.com', 'so.com', 'sougou']

export default defineNuxtPlugin(() => {
  const referrer = typeof document !== 'undefined' ? document.referrer : ''
  // console.log('referrer--', referrer)
  if (!referrer) return

  const refererStr = referrer.includes('?') ? referrer.split('?')[0]! : referrer
  // console.log('referrer--2', refererStr)
  const isFromSEO = seoList.some(seo => refererStr.includes(seo))
  if (!isFromSEO) return

  const days = 365 * 100
  const date = new Date()
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)

  const isDev = import.meta.dev
  const domainPart = isDev ? '' : 'domain=jufair.com;'

  document.cookie = `seoSearchSource=${refererStr}; ${domainPart}expires=${date.toUTCString()}; path=/`
})
